import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import ActionButton from '@/components/action_button/Index.vue';
import RaffleDraws from '@/components/v2/survey/CampaignRaffles';
let CampaignRaffle = class CampaignRaffle extends mixins(RouterParamsAppMixin) {
    get headers() {
        return [
            {
                text: 'Raffle Name',
                value: 'code',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Raffle Drawed At',
                value: 'code',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Prize',
                value: 'duration',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Campaign Name',
                value: 'active',
                align: 'left',
                sortable: false,
            },
        ];
    }
    goToRaffleDrawDetailsPage(uuid) {
        this.$router.push({
            name: 'raffle-draw-details',
            params: {
                uuid,
            },
        });
    }
};
CampaignRaffle = __decorate([
    Component({
        components: {
            PageTitle,
            RaffleDraws,
            ActionButton,
        },
    })
], CampaignRaffle);
export default CampaignRaffle;
